import React, {Component} from 'react';
import ContentItem from './ContentItem';

interface ContentHTMLItemProps {
  code: string;
  stripTags?:boolean;
}

export default class ContentHTMLItem extends Component<ContentHTMLItemProps, any> {
  shouldComponentUpdate(nextProps: Readonly<ContentHTMLItemProps>, nextState: Readonly<{}>, nextContext: any): boolean {
    return this.props.code !== nextProps.code || this.props.stripTags !== nextProps.stripTags;
  }

  render() {
    return <ContentItem code={this.props.code} placeholder={this.props.children}>
      {(item) => {
        if(!item || typeof(item) !== 'string') {
          return this.props.children || null;
        }
        let content = item as string;
        if(this.props.stripTags) {
          let el: Element|null = document.createElement('span');
          el.innerHTML = content;
          content = el.textContent || '';
        }
        return <span dangerouslySetInnerHTML={{__html: content}} />;
      }}
    </ContentItem>;
  }
}